const defaultRules = {
  required: (v) => Boolean(String(v ?? '').length) || 'Required field',
  requiredArray: (v) => Boolean(v.length) || 'Required field',
  min: (min) => (v) => v >= min || `Value mustn't be less ${min}`,
  max: (max) => (v) => v <= max || `Value mustn't be more ${max}`,
  number: (v) => typeof v === 'number' || 'Must be number',
  maxLength: (max) => (v) => (v && v.length <= max) || `Field cannot contain more than ${max} characters`,
  decimalPlacesCount: (v) => /^[0-9]*[.]?\d{1,2}$/.test(v) || 'Must be no more than two decimal places',
  combobox: (v) => typeof v !== 'string' || 'Select value from list',
  positiveNumber: (v) => v >= 0 || 'Value mustn\'t be negative',
};

const generateRule = (rule) => {
  if (typeof rule === 'string' && defaultRules[rule]) {
    return defaultRules[rule];
  }

  if (typeof rule === 'object' && defaultRules[rule.rule]) {
    return defaultRules[rule.rule](rule.value);
  }

  return false;
};

export const Validator = {
  createValidator(config) {
    const keys = Object.keys(config);
    const rules = keys.reduce((acc, key) => {
      acc[key] = config[key].reduce((accRules, item) => {
        const rule = generateRule(item);
        if (rule) {
          accRules.push(rule);
        }
        return accRules;
      }, []);
      return acc;
    }, {});

    return {
      getRulesByField: (fieldName) => rules[fieldName] || [],
      addRule: (fieldName, rule) => {
        if (rules[fieldName]) {
          rules[fieldName].push(rule);
        } else {
          rules[fieldName] = [rule];
        }
      },
    };
  },
  useValidator: (validator) => ({ computed: { validator: () => validator } }),
};
